module.exports = __webpack_public_path__ + "img/road.09228a67.jpg";